// @flow
import React from 'react';
import { defaultIconProps, type IconProps, IconSvgWrapper } from './base';

const VideoCallIcon = (props: IconProps) => (
  <IconSvgWrapper {...props}>
    <path
      fill={props.color}
      d="M22.0272 5.45522C21.768 5.3651 21.4869 5.35928 21.2242 5.4386C20.9614 5.51791 20.7305 5.6783 20.5644 5.89682L18.246 8.72042V6.14642C18.246 5.79633 18.107 5.46058 17.8594 5.21303C17.6119 4.96549 17.2761 4.82642 16.926 4.82642H3.00604C2.65595 4.82642 2.3202 4.96549 2.07265 5.21303C1.82511 5.46058 1.68604 5.79633 1.68604 6.14642V17.9064C1.68604 18.2565 1.82511 18.5922 2.07265 18.8398C2.3202 19.0873 2.65595 19.2264 3.00604 19.2264H16.926C17.2761 19.2264 17.6119 19.0873 17.8594 18.8398C18.107 18.5922 18.246 18.2565 18.246 17.9064V15.2292L20.5536 18.1944C20.6749 18.3577 20.8327 18.4902 21.0144 18.5815C21.1961 18.6728 21.3967 18.7202 21.6 18.72C21.7461 18.72 21.8913 18.6961 22.0296 18.6492C22.2933 18.5635 22.5227 18.3958 22.6845 18.1708C22.8464 17.9457 22.9323 17.6748 22.9296 17.3976V6.70682C22.9323 6.42925 22.8462 6.1581 22.6838 5.93294C22.5215 5.70778 22.2914 5.5404 22.0272 5.45522V5.45522ZM16.806 17.7864H3.12604V6.26642H16.806V17.7864ZM21.486 17.0472L18.246 12.8844V10.9896L21.486 7.04282V17.0472Z"
    />
  </IconSvgWrapper>
);

VideoCallIcon.defaultProps = defaultIconProps;

export default VideoCallIcon;
